import React, { FunctionComponent, useState } from 'react'
// import Image from 'next/image'
import clsx from 'clsx'
import { isUndefinedOrEmpty } from '@afterpay/utils/string'

import styles from './styles.module.css'
import { useGetAssetHeroSrc } from '../../../utils/post-checkout'
import { usePersonalization } from '../../../utils/personalization'
import { useMonitoringWithEnduringEventProperties } from '../../../integrations/monitoring'
import { TrackingEvent } from '../../../model/monitoring'

interface Props {
  alt?: string
  show?: boolean
  hasVariantImages?: boolean
  reservedSpaceClassName?: string
}

export const Image: FunctionComponent<Props> = ({ alt = '', show = false, hasVariantImages = false, reservedSpaceClassName }) => {
  const src = useGetAssetHeroSrc(hasVariantImages)
  const [isError, setIsError] = useState(isUndefinedOrEmpty(src))
  const [isLoaded, setIsLoaded] = useState(false)
  const {
    postCheckout: {
      asset: { id },
    },
  } = usePersonalization()
  const componentStyle = clsx(styles.imageWrapper, isLoaded && styles.imageLoaded)
  const reservedSpaceStyle = clsx(
    !isLoaded && styles.imageNotLoaded,
    !isLoaded && reservedSpaceClassName && styles[`imageReservedSpace_${reservedSpaceClassName}`]
  )
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  if (isError || !show) {
    return null
  }

  return (
    <div
      className={componentStyle}
      data-testid='postcheckout-image-wrapper'
      onClick={() => {
        logEvent(TrackingEvent.CLICK_POST_CHECKOUT_IMAGE, { assetId: id })
      }}
    >
      <img role='img' src={src} onError={() => setIsError(true)} onLoad={() => setIsLoaded(true)} alt={alt} className={reservedSpaceStyle} />

      {/*
    TODO: upgrade next to v13 to use native computed aspect ratio
    <Image src={assetHeroSrc} alt='' />
    */}
    </div>
  )
}
